import { useQuery } from 'react-query'
import { fetchMyProjects } from 'pages/ArcProjectsList/services'
import type { UseLatestProjectsResult } from '../interfaces'
import { LATEST_LIMIT, QUERY_RETRY, QUERY_STALE_TIME_MS } from '../constants'

export const useLatestProjects = (): UseLatestProjectsResult => {
  const { data, isLoading, isError } = useQuery(
    ['manager-dashboard', 'latest-projects'],
    () =>
      fetchMyProjects({
        page: 1,
        limit: LATEST_LIMIT,
        order_by: 'created_at',
        direction: 'desc',
      }),
    { staleTime: QUERY_STALE_TIME_MS, refetchOnWindowFocus: false, retry: QUERY_RETRY },
  )

  return {
    projects: data?.projects ?? [],
    isLoading,
    isError,
  }
}
